import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { FunctionsService } from '../../services/functions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { CandidatesJobsApply } from '../../models/candidatesJobsApply.model';
import { Jobs } from '../../models/jobs.model';
declare var $: any; 

@Component({
  selector: 'app-admin-candidate-apply-job',
  templateUrl: './admin-candidate-apply-job.component.html',
  styleUrls: ['./admin-candidate-apply-job.component.scss']
})
export class AdminCandidateApplyJobComponent implements OnInit {
  jobID: any;
  job: Jobs = new Jobs({});
  isLoading: boolean = false;
  candidatesJobsApply: CandidatesJobsApply[] = [];

  constructor(private functions: FunctionsService, private router: Router, private route: ActivatedRoute, private httpService: HttpService) {
    this.jobID = this.route.snapshot.paramMap.get('jobID');
    if (parseInt(this.jobID) != this.jobID) {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit(): void {
    this.getJob();
    this.getCandidatesJobApply(this.jobID);
  }

  getCandidatesJobApply(jobID: number) {
    this.isLoading = true;

    this.httpService.getCandidatesJobApply(jobID).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let list = response.data.list;
          list.forEach((element: any) => {
            this.candidatesJobsApply.push(new CandidatesJobsApply(element));
          });
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  getDetailsCandidateApply(candidateID: number) {
    this.candidatesJobsApply.forEach(element => {
      const candidatesJobsApply = new CandidatesJobsApply(element);
      if (candidatesJobsApply.getCandidates().getId() == candidateID) {
        localStorage.setItem('details-candidate-apply', JSON.stringify(candidatesJobsApply.getCandidates()));
        this.router.navigate(['admin/details-candidat', candidateID]);
      }
    });
  }

  calculateAge(dateBirth: any) {
    const currentDate = new Date().getTime();
    const dateOfBirth = new Date(dateBirth).getTime();
    const age = (currentDate - dateOfBirth) / (365 * 24 * 60 * 60 * 1000);
    return Math.floor(age);
  }
  
  getJob() {
    if (localStorage.getItem('job') && localStorage.getItem('job') != undefined) {
      const data = JSON.parse(localStorage.getItem('job') || "");
      this.job = new Jobs(data);
    }
  }

}
